module.exports = __webpack_public_path__ + "static/media/Tanya_Mahadwar.e9062b11.png";